// Customer types
export const CUSTOMERS = [
  { id: 'fedex', name: 'FedEx', color: 'bg-purple-100 text-purple-700' },
  { id: 'dhl', name: 'DHL', color: 'bg-yellow-100 text-yellow-700' },
  { id: 'getax', name: 'GeTax', color: 'bg-blue-100 text-blue-700' },
  { id: 'express', name: 'Express', color: 'bg-green-100 text-green-700' },
  { id: 'mover', name: 'Mover', color: 'bg-orange-100 text-orange-700' },
  { id: 'bpost', name: 'Bpost', color: 'bg-red-100 text-red-700' },
];

// Route types for GeTax
export const GETAX_ROUTE_TYPES = ['UPS', 'GETAX', 'Bloed', 'Staal', 'Diğer'];

// Rit options for Mover
export const MOVER_RIT_OPTIONS = [
  'Luik',
  'Luik 1',
  'Luik 2',
  'Luik 3',
  'Luik 4',
  'Luik 5',
  'Extra',
  'Hasselt',
  'President'
];

// Default form values by customer
export const getDefaultFormValues = (customerType = 'fedex', selectedFirm = '') => ({
  customer: customerType,
  firm_id: selectedFirm,
  date: new Date().toISOString().split('T')[0],
  route_number: '',
  route_type: '',
  rit_number: '',
  plaats: '',
  license_plate: '',
  driver_id: '',
  driver_name: '',
  copilot_id: '',
  copilot_name: '',
  km_start: '',
  km_end: '',
  hourly_rate: customerType === 'getax' ? '325' : customerType === 'express' ? '325' : customerType === 'mover' ? '78' : customerType === 'bpost' ? '0' : customerType === 'dhl' ? '0' : '40',
  start_cost: '0',
  stops: '',
  start_time: '08:00',
  end_time: '17:00',
  break_time: customerType === 'mover' ? '00:30' : '00:00',
  notes: ''
});
